import { DcBaseComponent } from '@deleteagency/dc';
import Flickity from 'flickity';
import GtmHelper from 'components/gtm-trigger/js/gtm-helper';

const CSS_CLASS_IS_ACTIVE = 'is-active';

export default class CaptionCarComponent extends DcBaseComponent {
    static getNamespace() {
        return 'caption-car';
    }

    static getRequiredRefs() {
        return ['container', 'captions', 'prev', 'next'];
    }

    onInit() {
        this.refs.captions[0].classList.add(CSS_CLASS_IS_ACTIVE);
        this._carousel = new Flickity(this.refs.container, {
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            setGallerySize: false
        });
        this._initControls();
        this._subscribeOnCarouselChange();
    }

    _initControls = () => {
        this.addListener(this.refs.prev, 'click', this._onPrevClick);
        this.addListener(this.refs.next, 'click', this._onNextClick);
    };

    _onPrevClick = (e) => {
        GtmHelper.send(null, { category: 'page', action: 'Content carousel', label: e.target.textContent.trim() });
        this._carousel.previous();
    };

    _onNextClick = (e) => {
        GtmHelper.send(null, { category: 'page', action: 'Content carousel', label: e.target.textContent.trim() });
        this._carousel.next();
    };

    _onSettle = (index) => {
        this.refs.captions.forEach((caption) => caption.classList.remove(CSS_CLASS_IS_ACTIVE));
        this.refs.captions[index].classList.add(CSS_CLASS_IS_ACTIVE);
    };

    _subscribeOnCarouselChange = () => {
        this._carousel.on('settle', this._onSettle);
    };
}
